import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TablerIconsModule } from 'angular-tabler-icons';
import { KendoModule } from 'src/app/kendo.module';
import { MaterialModule } from 'src/app/material.module';
import { ConnectorMdESignProcessRunService } from './connector-md-esign-process-run.service';
import { DbmCluESignRunProcessParams } from '../m-esign-process.model';
import { CluPuSnackbarService } from 'src/app/@public/@services/clupu-snackbar.service';

@Component({
    selector     : 'md-esign-process-run',
    templateUrl  : './md-esign-process-run.component.html',
    styleUrls: ['./md-esign-process-run.component.scss'],
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    imports: [FormsModule, MaterialModule, TablerIconsModule, KendoModule, CommonModule],
    providers : [ConnectorMdESignProcessRunService, CluPuSnackbarService]
})
export class MdESignProcessRunComponent implements OnInit 
{
    esignLinkItem : any;
    esignParams : DbmCluESignRunProcessParams = new DbmCluESignRunProcessParams();
    confirmationChecked : boolean = false;
    constructor(private connector : ConnectorMdESignProcessRunService, @Inject(MAT_DIALOG_DATA) private dataE: any, public matDialogRef: MatDialogRef<MdESignProcessRunComponent>, private _snackbarService : CluPuSnackbarService) {
        this.esignLinkItem = dataE.esignLinkItem;
        this.esignParams.ESIGN_TOKEN = dataE.esignToken;
        this.esignParams.ESIGN_CODE = this.esignLinkItem.ESIGN_CODE;
        this.esignParams.ESIGN_SF_GENRE = this.esignLinkItem.ESIGN_S_GENRE == '1' ? 1 : 0;
        this.esignParams.ESIGN_SF_PRENOM = this.esignLinkItem.ESIGN_S_PRENOM;
        this.esignParams.ESIGN_SF_NOM = this.esignLinkItem.ESIGN_S_NOM;
    }

    ngOnInit() { }

    showProgressBar : boolean = false;
    doRunDocumentESignProcessAction_PUPRemDocsESign(){
        this.showProgressBar = true;
        this.connector.doRunDocumentESignProcessAction_PUPRemDocsESign(this.esignParams).subscribe({
            next : (res : any) => {
                console.log(res);
                this.showProgressBar = false;
                this.matDialogRef.close(res);
                this._snackbarService.displayMessage("SUCCESS", "Le processus de signature a été effectué avec succès.");
            }, 
            error : (err : any) => {
                console.error(err);
                if(err.error != undefined && err.error.Message != undefined){ this._snackbarService.displayMessage("ERROR", err.error.Message); }
                else { this._snackbarService.displayMessage("ERROR", "Une erreur est survenue lors de l'enregistrement.."); }
                this.showProgressBar = false; 
            }
        })
    }
}